import { combineEpics } from 'redux-observable'
import { Observable } from 'rxjs'
import * as authenticationDuck from 'store/ducks/authentication'
import { managedCompany } from '../services/user'

// Actions
export const FETCH_REQUEST = 'couriers/FETCH_REQUEST'
export const FETCH_SUCCESS = 'couriers/FETCH_SUCCESS'
export const FETCH_FAILURE = 'couriers/FETCH_FAILURE'

// Reducer
const INITIAL_STATE = {
  isLoading: false,
  entities: {},
  ordoned: [],
  result: [],
  errors: [],
}

export function reducer(state = INITIAL_STATE, action = {}) {
  switch (action.type) {
    case FETCH_REQUEST:
      return {
        ...state,
        isLoading: true,
        result: action.reset ? [] : state.result,
        entities: action.reset ? {} : state.entities,
        errors: action.reset ? [] : state.errors,
        ordoned: action.reset ? [] : state.ordoned,
      }
    case FETCH_SUCCESS:
      return {
        ...state,
        isLoading: false,
        result: action.result,
        entities: action.entities,
        ordoned: action.ordoned,
        errors: [],
      }
    case FETCH_FAILURE:
      return {
        ...state,
        isLoading: false,
        result: [],
        entities: {},
        errors: action.errors,
        ordoned: [],
      }
    default:
      return state
  }
}

// Actions Creators
export const fetchRequest = (company, reset = true) => {
  return { type: FETCH_REQUEST, company, reset }
}

export const fetchSuccess = (payload) => ({
  type: FETCH_SUCCESS,
  result: payload['hydra:member'].map((courier) => courier.id),
  ordoned: payload['hydra:member'],
  entities: payload['hydra:member'].reduce((entities, courier) => ({ ...entities, [courier.id]: courier }), {}),
})

export const fetchFailure = (errors = []) => ({
  type: FETCH_FAILURE,
  errors,
})

// Epics
export const epic = combineEpics(fetchRequestEpic)

export function fetchRequestEpic(action$) {
  return action$.ofType(FETCH_REQUEST).mergeMap((action) =>
    Observable.ajax(managedCompany(action.company))
      .map((res) => fetchSuccess(res.response))
      .catch((err) => {
        if (typeof err === 'object' && (err.response || {}).code === 401) {
          return Observable.of(authenticationDuck.refreshTokenRequest(action))
        }

        return Observable.of(fetchFailure())
      }),
  )
}
